module.exports = __webpack_public_path__ + "static/img/9.e385fb9b.jpg";